import { type ReactNode, createContext, useContext } from 'react';
import type * as React from 'react';

import { cn } from '../../../lib';
import { type FlexGap, Stack } from '../flex';

const IconListContext = createContext<ReactNode>(null);

type IconListProps = React.ComponentProps<'ul'> & { icon: ReactNode; gap?: FlexGap };

function IconList({ icon, gap, ...props }: IconListProps) {
  return (
    <IconListContext.Provider value={icon}>
      <Stack asChild gap={gap}>
        <ul {...props} />
      </Stack>
    </IconListContext.Provider>
  );
}

type IconListItemProps = React.ComponentProps<'li'> & { icon?: ReactNode };

function IconListItem({ icon, className, children, ...props }: IconListItemProps) {
  const listIcon = useContext(IconListContext);
  return (
    <li className={cn('flex items-start gap-3', className)} {...props}>
      <span className="mt-0.5 shrink-0">{icon ?? listIcon}</span>
      <div className="flex-1">{children}</div>
    </li>
  );
}

export { IconList, IconListItem };
